import { isStreamIQ } from '@/shared/lib'

export async function getGetZeroRowViewModule() {
    if (isStreamIQ()) {
        try {
            const module =
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                await require('@/clients/streamiq/features/VOD/components/ZeroRowView')

            return module.default
        } catch (error) {
            console.warn(
                'ZeroRowView module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
}
